import { pathToModuleStyle } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { getResourceName } from '@spotify/plugin-confidence-projects-react';

import { isRuleUri } from '../resourceUri';
import { DefaultResourcePreview } from './DefaultResourcePreview';
import { FlagArtifactPreview } from './FlagArtifactPreview';
import { MetricArtifactPreview } from './MetricArtifactPreview';
import { RuleArtifactPreview } from './RuleArtifactPreview';
import { SegmentArtifactPreview } from './SegmentArtifactPreview';
import { WorkflowArtifactPreview } from './WorkflowArtifactPreview';

const FLAG_PREFIX = 'flags/';
const SEGMENT_PREFIX = 'segments/';
const METRIC_PREFIX = 'metrics/';
const WORKFLOW_PREFIXES = [
  'workflows/abtest/instances/',
  'workflows/rollout/instances/',
  'workflows/analysis/instances/',
  'workflows/reanalysis/instances/',
];

interface ResourcePreviewProps {
  artifact: AttachmentFragment;
}

export const ResourcePreview = ({ artifact }: ResourcePreviewProps) => {
  const resourceName = getResourceName(artifact.uri);
  const label = pathToModuleStyle(artifact.uri)?.label ?? 'Resource';

  if (isRuleUri(artifact.uri)) {
    return <RuleArtifactPreview resourceName={resourceName} />;
  }
  if (resourceName.startsWith(FLAG_PREFIX)) {
    return <FlagArtifactPreview resourceName={resourceName} />;
  }
  if (resourceName.startsWith(SEGMENT_PREFIX)) {
    return <SegmentArtifactPreview resourceName={resourceName} />;
  }
  if (resourceName.startsWith(METRIC_PREFIX)) {
    return <MetricArtifactPreview resourceName={resourceName} />;
  }
  if (WORKFLOW_PREFIXES.some(prefix => resourceName.startsWith(prefix))) {
    return (
      <WorkflowArtifactPreview resourceName={resourceName} label={label} />
    );
  }

  return <DefaultResourcePreview artifact={artifact} label={label} />;
};
